import { Application } from "@hotwired/stimulus"

import ContactDialogController from "./controllers/contact_dialog_controller"
import SwiperController from "./controllers/swiper_controller"
import AccordionsController from "./controllers/accordions_controller"
import StickyController from "./controllers/sticky_controller"
import FooterController from "./controllers/footer_controller"
import TabsController from "./controllers/tabs_controller"
import RevealController from "./controllers/reveal_controller"
import SelectorController from "./controllers/selector_controller"
import SpecialistFilterFormController from "./controllers/specialist_filter_form_controller"

window.Stimulus = Application.start()
Stimulus.register("swiper", SwiperController)
Stimulus.register("accordions", AccordionsController)
Stimulus.register('contact-dialog', ContactDialogController)
Stimulus.register('sticky', StickyController)
Stimulus.register('footer', FooterController)
Stimulus.register('tabs', TabsController)
Stimulus.register('reveal', RevealController)
Stimulus.register('selector', SelectorController)
Stimulus.register('specialist-filter-form', SpecialistFilterFormController)